import {
  useV2CreateLobApprovalMutation,
  useV2UpdateLobApprovalMutation,
  useV2DeleteLobApprovalMutation,
} from "@generated";
import type { LobApprovalFormValues } from "../types/LobApproval";

const lobApprovalBody = (values: LobApprovalFormValues, id?: string) => ({
  data: {
    type: "lob-approvals",
    ...(id ? { id: Number(id) } : {}),
    attributes: {
      "required-approvals": values.requiredApprovals,
      "submitter-may-approve": values.submitterMayApprove,
      "limit-approvals-to-team": values.limitApprovalsToTeam,
    },
    relationships: values.sectionId
      ? {
          section: { data: { type: "sections", id: Number(values.sectionId) } },
        }
      : undefined,
  },
});

export const useLobApprovalMutations = () => {
  const [create, createState] = useV2CreateLobApprovalMutation();
  const [update, updateState] = useV2UpdateLobApprovalMutation();
  const [destroy, destroyState] = useV2DeleteLobApprovalMutation();

  return {
    create: (values: LobApprovalFormValues) =>
      create({ body: lobApprovalBody(values) }).unwrap(),
    update: (id: string, values: LobApprovalFormValues) =>
      update({ id: Number(id), body: lobApprovalBody(values, id) }).unwrap(),
    destroy: (id: string) => destroy({ id: Number(id) }).unwrap(),
    states: { createState, updateState, destroyState },
  };
};
